module.exports = __webpack_public_path__ + "front/img/b26_0.6cc937cb.jpg";